import { z } from "zod";

export const cbuFilterSchema = z.object({
  search: z.any().optional(),
  account_type: z.any().optional(),
});
